import React from 'react';
import { UnitConverter } from './UnitConverter';

const units = [
  { key: 'lbinch', label: 'lb / sq inch' },
  { key: 'lbfeet', label: 'lb / sq feet' },
  { key: 'kgcm',   label: 'kg / cm²' },
  { key: 'kgm',    label: 'kg / m²' },
  { key: 'tm',     label: 't / m²' },
  { key: 'nmm',    label: 'N / mm²' },
];

// Base: lb / sq inch
const factors = {
  lbinch: 1,
  lbfeet: 144,
  kgcm:   0.07031,
  kgm:    703.07,
  tm:     0.703,
  nmm:    0.00689,
};

export const ConvStress = () => (
  <UnitConverter
    title="Stress"
    units={units}
    factors={factors}
    explanationTitle="Units of stress"
    explanation="1 t / ft² = 1000 N / mm². Stress is the average force per unit area; the English system's 1 ton per square foot is approximately 1000 times the N / mm² in the metric system."
  />
);
